import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_SOCKET_URL!, {
  autoConnect: false,
  path: "/socket-api/socket.io",
  extraHeaders: {
    Authorization: localStorage.getItem("token") || "",
  },
});
